// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { AXIS_WIDTH } from '@/membership/utilities/chart-geometry';
import { Stack, Typography } from '@mui/material';

interface Props {
  // Top down, one per tick, already spaced evenly by the scale that made them.
  labels: string[];
  isRight?: boolean;
}

/**
 * The count gutter beside a plot. Both sides carry one, so a bar at the far end
 * of a long window is read against a nearby axis rather than across the width
 * of the chart.
 */
export function ChartAxis(props: Props) {
  const isRight = props.isRight === true;

  return (
    <Stack
      justifyContent="space-between"
      alignItems={isRight ? 'flex-start' : 'flex-end'}
      sx={{
        width: AXIS_WIDTH,
        pl: isRight ? 0.75 : 0,
        pr: isRight ? 0 : 0.75,
        flexShrink: 0,
        borderLeft: isRight ? 1 : 0,
        borderRight: isRight ? 0 : 1,
        borderColor: 'divider',
      }}
    >
      {props.labels.map((label) => (
        <Typography
          key={label}
          variant="caption"
          color="text.secondary"
          sx={{ fontVariantNumeric: 'tabular-nums', lineHeight: 1 }}
        >
          {label}
        </Typography>
      ))}
    </Stack>
  );
}
